export const keyCodes = {
    escape: 27,
};

export const getKeyCode = e => e.which || e.charCode || e.keyCode || 0;
